import React from "react";

const TermsAndConditions = () => {
  return (
    <div className="max-w-4xl mx-auto p-6 space-y-6">
      <h1 className="font-bold uppercase text-2xl">TERMS & CONDITIONS</h1>
      <div>
        <h2 className="font-bold text-lg uppercase ">
          1. Usage of mobile application
        </h2>
        <p>
          1.1. By downloading or using the BundaMoneyNow app, these terms will
          automatically apply to you – you should make sure therefore that you
          read them carefully before using the app. You’re not allowed to copy
          or modify the app, any part of the app, or our trademarks in any way.
          You’re not allowed to attempt to extract the source code of the app,
          and you also shouldn’t try to translate the app into other languages
          or make derivative versions.
        </p>
        <p>
          1.2. The app itself, and all the trademarks, copyright, database
          rights, and other intellectual property rights related to it, belong
          to Bunda Investment (reg number <strong>PVT-LRUMGZLV</strong>),
          hereafter referred to as “Bunda”.
        </p>
        <p>
          1.3. Bunda is committed to ensuring that the app is as useful and
          efficient as possible. For that reason, we reserve the right to make
          changes to the app or to charge for its services, at any time and for
          any reason. We will never charge you for the app or its services
          without making it very clear to you exactly what you’re paying for.
        </p>
        <p>
          1.4. The BundaMoneyNow app stores and processes personal data that you
          have provided to us, to provide our Service. It’s your responsibility
          to keep your phone and access to the app secure. We therefore
          recommend that you do not jailbreak or root your phone, which is the
          process of removing software restrictions and limitations imposed by
          the official operating system of your device. It could make your phone
          vulnerable to malware/viruses/malicious programs, compromise your
          phone’s security features and it could mean that the BundaMoneyNow app
          won’t work properly or at all.
        </p>
        <p>
          1.5. The app does use third-party services that declare their Terms
          and Conditions. Third-party service providers used by the app. By
          accepting these terms and conditions you will also be consenting to
          the terms and conditions of the third-party apps which you can access
          here:
        </p>
        <p>
          1.6. BundaMoneyNow collects data of your phone, such as installed
          applications to provide a segmented risk profile, generate aggregated
          statistical information to assess your creditworthiness, better
          evaluate your loan application and calculate a more accurate credit
          score. To protect your identity, we remove all personal identifiers
          (if any) and pseudonymise such information.
        </p>
        <p>
          1.7. You should be aware that there are certain things that Bunda will
          not take responsibility for. Certain functions of the app will require
          the app to have an active internet connection. The connection can be
          Wi-Fi or provided by your mobile network provider, but Bunda cannot
          take responsibility for the app not working at full functionality if
          you don’t have access to Wi-Fi, and you don’t have any of your data
          allowance left.
        </p>
        <p>
          1.8. If you’re using the app outside of an area with Wi-Fi, you should
          remember that the terms of the agreement with your mobile network
          provider will still apply. As a result, you may be charged by your
          mobile provider for the cost of data for the duration of the
          connection while accessing the app, or other third-party charges. In
          using the app, you’re accepting responsibility for any such charges,
          including roaming data charges if you use the app outside of your home
          territory (i.e. region or country) without turning off data roaming.
          If you are not the bill payer for the device on which you’re using the
          app, please be aware that we assume that you have received permission
          from the bill payer for using the app.
        </p>
        <p>
          1.9. Along the same lines, Bunda cannot always take responsibility for
          the way you use the app i.e. You need to make sure that your device
          stays charged – if it runs out of battery and you can’t turn it on to
          avail the Service, Bunda cannot accept responsibility.
        </p>
        <p>
          1.10. With respect to Bunda’s responsibility for your use of the app,
          when you’re using the app, it’s important to bear in mind that
          although we endeavour to ensure that it is updated and correct at all
          times, we do rely on third parties to provide information to us so
          that we can make it available to you. Bunda accepts no liability for
          any loss, direct or indirect, you experience as a result of relying
          wholly on this functionality of the app.
        </p>
        <p>
          1.11. At some point, we may wish to update the app. The requirements
          for the system (and for any additional systems we decide to extend the
          availability of the app to) may change, and you’ll need to download
          the updates if you want to keep using the app. BundaMoneyNow does not
          promise that it will always update the app so that it is relevant to
          you and/or works with the Android version that you have installed on
          your device. However, you promise to always accept updates to the
          application when offered to you. We may also wish to stop providing
          the app, and may terminate use of it at any time without giving notice
          of termination to you. Unless we tell you otherwise, upon any
          termination, (a) the rights and licences granted to you in these terms
          will end; (b) you must stop using the app, and (if needed) delete it
          from your device.
        </p>
      </div>
      <div>
        <h2 className="font-bold text-lg uppercase ">2. Representations</h2>
        <p>2.1 You represent, on your own behalf, that:</p>
        <p>
          2.2 You are a natural person, of at least eighteen (18) years of age,
          with legal capacity, and you appear on your own behalf to enter into
          this Agreement with us. When you apply for a loan, you instruct,
          consent to and authorize BundaMoneyNow to provide certain information
          about you to Choice Micro Finance Bank Limited. This information may
          include all data held by BundaMoneyNow about you and/or information
          provided by you about your Safaricom M-PESA Buy Goods Till account. It
          specifically includes your mobile phone number, your name, surname,
          date of birth, identity or passport number and includes all
          information relating to your business linked to your M-PESA Buy Goods
          Till account.
        </p>
        <p>
          2.3 Before entering into this Agreement, you have read and understood
          the provisions herein and you agree to comply with the provisions
          contained in this Agreement.
        </p>
        <p>
          2.4 By clicking the “Accept” button within the BundaMoneyNow App, you
          agree that you have read, and agree to comply with the terms and
          conditions of this Agreement, the Privacy Policy and the Privacy
          Notice, including and without limitation to, the terms, rate and
          repayment schedule of the Loan set forth on the Cover Page at the time
          you accept the Loan offered to you.
        </p>
        <p>
          2.5 You further represent that all documents related to this Agreement
          and any Loan were available for your review through the BundaMonneyNow
          App.
        </p>
        <p>
          2.6 All information and documents provided by you to BundaMoneyNow for
          your Loan Application on the BundaMoneyNow App are true, complete and
          correct.
        </p>
        <p>
          2.7 By accepting this Agreement, you consent to us collecting and
          using technical information about your Equipment and use of the
          BundaMoneyNow App and any related partnered software, hardware and
          peripherals for services that are internet-based or wireless to
          improve our products and to provide any services to you.
        </p>
        <p>
          2.8 You will use the proceeds of any Loan only for lawful activities
          and purposes.
        </p>
        <p>
          2.9 You agree that any Loan shall be disbursed to the number you have
          registered with BundaMoneyNow in accordance with the terms and
          conditions of this Agreement.
        </p>
        <p>
          2.10. You agree that if your account is used and/or is involved in any
          fraudulent activities, you consent that Choice Microfinance Bank will
          use the information collected about you and to take appropriate legal
          action with the relevant authorities.
        </p>
      </div>
      <div>
        <h2 className="font-bold text-lg uppercase ">3. Loan application</h2>
        <p>
          3.1 All loans are provided by Choice Micro Finance Bank Limited, a
          limited liability company registered in Kenya and regulated by the
          Central Bank of Kenya.
        </p>
        <p>
          3.2 When you apply for a loan, you also consent for Choice Micro
          Finance Bank Limited through BundaMoneyNow to collect information
          about you and/or your business from Kenyan credit bureau.
        </p>
        <p>
          3.3 If your application is approved, BundaMoneyNow shall call you
          and/or send an SMS to you to confirm:
        </p>
        <ul className="list-disc list-inside space-y-2">
          <li>the Loan Amount</li>
          <li>the Service Fee (% of loan amount);</li>
          <li>the Repayment Amount</li>
          <li>the Due Date</li>
        </ul>
        <p>
          3.4 You may accept or decline to take up a loan from Choice Micro
          Finance Bank Limited via a telephone call with a Bunda agent.
        </p>
        <p>
          3.5 If your application is approved, the loan shall be paid directly
          into your M-PESA account.
        </p>
        <p>
          3.6 Choice Micro Finance Bank Limited shall not be required to provide
          reasons to you for declining or approving your application for a loan.
        </p>
        <p>
          3.7 These terms and conditions may change from time to time. You are
          therefore required to read these terms and conditions every time
          before you apply for a loan.
        </p>
      </div>
      <div>
        <h2 className="font-bold text-lg uppercase ">4. Loan repayment</h2>
        <p>
          4.1 Repayment of the loan shall be by M-PESA to the provided Choice
          Micro Finance Bank Limited paybill or Buy Goods Till.
        </p>
        <p>
          4.2 You may choose to pay the Repayment Amount on or before the Due
          Date but thereafter, if the Repayment Amount has not been paid in
          full, you are in default.
        </p>
        <p>
          4.3 Choice Micro Finance Bank Limited reserves the right to set a
          minimum amount for valid partial prepayments i.e. any amount paid
          before the Due Date.
        </p>
        <p>
          4.4 If a loan is not repaid in full by the due date, a fee of 2% on
          the outstanding balance will be charged per day until payment is done
          in full.
        </p>
      </div>
      <div>
        <h2 className="font-bold text-lg uppercase ">5. STATEMENTS</h2>

        <p>
          5.1 You will be able to view the balance of any outstanding Loan, a
          history of all Loan Applications made, and a history of all amounts
          paid on request from Choice Micro Finance Bank Limited via Bunda.
        </p>

        <p>
          5.2 If required, these statements may be emailed to you if a valid
          email address is provided.
        </p>
      </div>
      <div>
        <h2 className="font-bold text-lg uppercase ">6. CREDIT BUREAU</h2>
        <p>
          You confirm and acknowledge that Choice Bank may from time-to-time
          request and provide information to Credit Reference Bureau regarding
          your credit history as well as obtain the corresponding reports. If we
          intend to submit a credit report to a Credit Reference Bureau for your
          breach of the provisions of this Agreement, we shall provide you with
          seven (7) days’ notice prior to such submission. After providing you
          with this notice, we shall notify you within 30 days of submitting a
          negative report that such a report has been submitted to any Credit
          Reference Bureau.
        </p>
      </div>
      <div>
        <h2 className="font-bold text-lg uppercase ">
          7. Exclusion of liability
        </h2>
        <p>
          Choice Micro Finance Bank Limited and/or Bunda shall not be
          responsible for any loss suffered by you should the Service be
          interfered with or become unavailable by reason of (a) the failure of
          any of your Equipment, or (b) any other circumstances whatsoever not
          within Choice’s or Bunda’s control, including, without limitation,
          force majeure or error, interruption, delay or non-availability of the
          service as a result of any terrorist or any enemy action, equipment
          failure, loss of power, adverse weather or atmospheric conditions, and
          failure of any public or private telecommunications system. If for any
          reason other than a reason mentioned above, the Service is interfered
          with or unavailable, Choice’s/Bunda’s liability under this Agreement
          in respect thereof shall be to re-establish the Service as soon as
          reasonably practicable.
        </p>
      </div>
      <div>
        <h2 className="font-bold text-lg uppercase ">
          8. Enforcement upon default
        </h2>
        <p>
          You agree that in case of any default by you on any of your
          obligations under this Agreement, we may obtain the payment of the
          Total Payable Amount through any procedures available to us under the
          applicable law including but not limited to Choice bank’s right to set
          off all your accounts without your consent and without notice to you.
          Choice Bank may sell, cede, assign or transfer any of our rights or
          obligations under this agreement or arrange for any other person to
          carry out any of our rights or obligations under this agreement
          without your consent and without notice to you.
        </p>
      </div>
      <div>
        <h2 className="font-bold text-lg uppercase ">9. Assignment</h2>
        <p>
          You agree that You shall not assign any of your rights under this
          Agreement, transfer any of your obligations under this Agreement,
          sub-contract or delegate any of your obligations under this Agreement
          nor charge or deal in any other manner with this Agreement any of your
          rights or obligations.
        </p>
      </div>
      <div>
        <h2 className="font-bold text-lg uppercase ">
          10. Disclosure of information
        </h2>
        <p>
          You hereby expressly consent and authorise Choice Micro Finance Bank
          Limited and Bunda to disclose, record and or utilize your personal or
          other information relating to your Choice Micro Finance Bank Limited
          Account.
        </p>
        <p>This shall include sharing this information with:</p>
        <ul className="list-disc list-inside space-y-2">
          <li>
            any local or international law enforcement or competent regulatory
            or governmental agency/ies so as to assist in the prevention,
            detection, investigation or prosecution of criminal activities or
            fraud;
          </li>
          <li>
            service providers, dealers, agents or any other associate company of
            Choice Micro Finance Bank Limited and Bunda for reasonable
            commercial purposes;
          </li>
        </ul>
      </div>
      <div>
        <h2 className="font-bold text-lg uppercase ">11. Miscellaneous</h2>
        <ul className="list-disc list-inside space-y-2">
          <li>
            You hereby consent to Choice Micro Finance Bank Limited ceding and
            assigning all and any rights or obligations accruing to it under
            this Agreement to any third party without first obtaining any
            further consent from you.
          </li>
          <li>
            If any provision of these terms and conditions shall be found by any
            duly appointed arbitrator, court or administrative body of competent
            jurisdiction to be invalid or unenforceable, the invalidity or
            unenforceability of such provision shall not affect the other
            provisions herein.
          </li>
        </ul>
      </div>
      <div className="mb-12">
        <h2 className="font-bold text-lg uppercase ">12. DISPUTE RESOLUTION</h2>

        <p>
          12.1 The parties shall resolve any dispute, controversy or claim
          arising out of or in relation to this agreement, or the breach,
          termination or invalidity as per the provisions below which shall be
          the exclusive mechanism for resolving any dispute that may arise from
          time to time and are express condition(s) precedent to litigation of
          the dispute.
        </p>

        <p>
          12.2 Negotiations:12.2.1 A party shall send a written notice to the
          other party of any dispute ("Dispute Notice") by negotiating and
          consultation between themselves, including not fewer than 2
          negotiation sessions.
        </p>

        <p>
          12.2.2 If the dispute cannot be resolved within 7 days from the date
          of the dispute notice, either party may initiate Litigation.
        </p>

        <p>
          12.3 Litigation as a final resort - If the parties cannot resolve any
          dispute for any reason following negotiations , [BO1] either party may
          file suit in a court of competent jurisdiction in the Republic of
          Kenya.
        </p>
      </div>
    </div>
  );
};

export default TermsAndConditions;
